module.exports = __webpack_public_path__ + "static/media/sf-pro-text-medium.df5baf8d.woff2";